export enum InspectionFeeFamily {
    Interior = 1,
    Bodywork = 2,
    Mechanical = 3,
}

export const InspectionFeeFamilyLabel: Record<InspectionFeeFamily, string> = {
    [InspectionFeeFamily.Interior]: 'Intérieur',
    [InspectionFeeFamily.Bodywork]: 'Extérieur',
    [InspectionFeeFamily.Mechanical]: 'Mécanique',
}
